import { http } from '../../../../api/http';
import type { NotaCredito, NotaCreditoCreateRequest } from '../types/notaCredito.types';

export class NotaCreditoService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/nota-credito',
  };

  public static async getAll(): Promise<NotaCredito[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching notas de credito:', error);
      throw error;
    }
  }

  public static async getById(id: number): Promise<NotaCredito> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching nota de credito:', error);
      throw error;
    }
  }

  public static async save(data: NotaCreditoCreateRequest): Promise<NotaCredito> {
    try {
      const response = await http.post(this.ENDPOINTS.BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error saving nota de credito:', error);
      throw error;
    }
  }

  public static async update(id: number, data: NotaCreditoCreateRequest): Promise<NotaCredito> {
    try {
      const response = await http.put(`${this.ENDPOINTS.BASE}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating nota de credito:', error);
      throw error;
    }
  }

  public static async delete(id: number): Promise<boolean> {
    try {
      await http.delete(`${this.ENDPOINTS.BASE}/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting nota de credito:', error);
      throw error;
    }
  }
}
